// extracted by mini-css-extract-plugin
export default {"menuContent":"SideMenu_menuContent__Y3cVs"};